import { render } from "./ReportsSystemView.vue?vue&type=template&id=5905492d&scoped=true"
import script from "./ReportsSystemView.vue?vue&type=script&lang=js"
export * from "./ReportsSystemView.vue?vue&type=script&lang=js"

import "./ReportsSystemView.vue?vue&type=style&index=0&id=5905492d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5905492d"]])

export default __exports__